import { render, staticRenderFns } from "./QuestionOption.vue?vue&type=template&id=588ff06a"
import script from "./QuestionOption.vue?vue&type=script&lang=js"
export * from "./QuestionOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports